// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ITagResponseSchema {
  /** Количество отзывов по данному тегу **/
  count: number;
  /** Есть ли активный фильтр по данному тегу **/
  isSelected: boolean;
  /** Текст тега **/
  title: string;
  /** Значение тега **/
  type: EType;
}
export enum EType {
  /** Придомовая территория **/
  'Adjoining_territory' = 'adjoining_territory',
  /** Строительство **/
  'Construction' = 'construction',
  /** Застройщик **/
  'Developer' = 'developer',
  /** Район **/
  'District' = 'district',
  /** Отделка **/
  'Flat' = 'flat',
  /** Дом **/
  'House' = 'house',
  /** Инфраструктура **/
  'Infrastructure' = 'infrastructure',
  /** Дети **/
  'Kids' = 'kids',
  /** управляющая компания **/
  'Management_company' = 'management_company',
  /** Парковка **/
  'Parking' = 'parking',
  /** Покупка **/
  'Purchase' = 'purchase',
  /** Транспортная доступность **/
  'Transport_affordable' = 'transport_affordable',
}
